export default (tokens) => ({
    radiusPrimary: tokens.radius30,
});
